<!--    Display error code when login by token failure-->
<!--    Display error code when login by token failure-->

<!--    Display error code when login by token failure-->
@if(this.displayErrorMessage ) {
  <div class="alert alert-danger">
    {{ this.displayErrorMessage }}
  </div>
}

<form
  [formGroup]="form"
  (keydown.enter)="getHintEmail()"
  *transloco="let translated"
>
  <div class="form-group mb-4">
    <label class="form-label" for="username">
      Tên đăng nhập:
      <!-- Tên đăng nhập của bạn -->
      <span class="text-danger">(*)</span>
    </label>
    <input
      formControlName="username"
      zaaAutofocus
      type="text"
      id="username"
      class="form-control form-control-lg"
      placeholder="Tên tài khoản của bạn"
    />
  </div>
  <div class="form-group mb-4">
    @if ((ENABLE_CHOOSE_ACCOUNT_TYPE && this.ACCOUNT_TYPES) && !isMobile) {
      <div class="form-group">
        <label for="" class="form-label">
          Loại tài khoản <span class="text-danger">*</span>
        </label>
        <br />
        <app-input-app [ACCOUNT_TYPES]="ACCOUNT_TYPES" [formGroup]="this.form"></app-input-app>
      </div>
      }
  </div>

  <button
    (click)="this.next()"
    type="button"
    class="btn-block btn btn-lg btn-primary waves-effect waves-themed mt-2"
    [disabled]="!form.get('typeAccount')?.value || !form.get('username')?.value || showSpinner"
    [ngClass]="{ 'cursor-default': !form.get('typeAccount')?.value || !form.get('username')?.value || showSpinner }"
  >
    @if (this.showSpinner) {
    <span
      class="spinner-border spinner-border-sm mr-2"
      role="status"
      aria-hidden="true"
    ></span>
    } Tiếp tục
  </button>

  <div class="d-flex align-items-center justify-content-center ">
    <a
      (click)="this.goBack()"
      type="button"
      class="btn btn-lg waves-effect waves-themed text-primary"
    >
      <i class="fal fa-long-arrow-left mr-2"></i>
      Quay lại đăng nhập
    </a>
  </div>
</form>
